import React from "react";
import {  useState } from "react";
import Action from "./Action";
import ShowItems from "./ShowItems";
import styles from "../NotesPage.module.scss";

import { deleteNotes, getNotesData, patchNotes,getNotes } from "service/NotesService";
import Notification from "utils/Notifications";
const Items = ({ id, body, createdAt, archived, action }) => {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const onDeleteNote = async (item) => {
    
  
    await deleteNotes(id);
    setNotify({
      isOpen: true,
      message: "Публикация успешно удалена",
      type: "success",
    });
    action((notes) => notes.filter((note) => note.id !== item));
      
    
  };
  const [data, setData] = useState([]);
  const onArchiveNote = async (item) => {
    if (!archived){
      await patchNotes(id);
      setNotify({
      isOpen: true,
      message: "Публикация успешно занесена в архив",
      type: "success",
    });
    
    action((notes) =>
    notes.map((note)  => {
      if (note.id === item) {
        return { ...note, archived: !note.archived };
      }
      return note;
    }));
  }
     else {
      let response = await patchNotes(id);
      setNotify({
      isOpen: true,
      message: "Публикация успешно вынесена из архива",
      type: "success",
    });
    action((notes) =>
    notes.map((note) => {
      if (note.id === item) {
        return { ...note, archived: !note.archived };
      }
      return note;
    }));
     }
  };

  return (
    <div className={styles["note-item"]}>
      <ShowItems
        id = {id}
        body={body}
        createdAt={createdAt}
        archived={archived}
        action={action}
      />
      
      <Action
        onDeleteNote={onDeleteNote}
        onArchiveNote={onArchiveNote}
        id={id}
        archived={archived}
      />
       <Notification notify={notify} setNotify={setNotify} />
    </div>
    
  );
};

export default Items;
